export default {
    connections: []
}